import useFetchUser from 'src/Hooks/Queries/useFetchUser';

import UserAvatar from '../../UserAvatar';

import styles from './NavBarMenuProfile.module.scss';

const NavBarMenuProfile = () => {
  const { data } = useFetchUser();
  return (
    <div className={styles.container}>
      <UserAvatar />
      <div className={styles.textColumn}>
        <div className={styles.name}>{[data?.firstName, data?.lastName].join(' ')}</div>
      </div>
    </div>
  );
};

export default NavBarMenuProfile;
